import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";

function TopHeader() {
    
    const location = useLocation();
    const dirPath = location.pathname.split('/');

    const navigate = useNavigate();
    const LOCAL_URL = window.location.origin;
    const logOut = () => {
        localStorage.setItem('login', JSON.stringify({
            login: false,
            token: null,
            userInfo: null
        }));
        window.localStorage.clear();
        navigate("/");
        window.location.reload();
    }
    return (
        <div className="page-top">
            <div className="row">
                <div className="col-md-7">
                    <div className="page-head">
                        <p>{location.pathname ? (location.pathname !== 'Dashboard' && ("Dashboard" + location.pathname) || 'Dashboard') : ''}</p>
                        <h2>{(dirPath && dirPath[1])} {dirPath[2] && '/' + dirPath[2].substring(0, 5)} </h2>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="menu-right w-100">
                        <ul className="menu-icon-list">
                            <li>
                                <a onClick={logOut} ><i className="fas fa-sign-out-alt"></i></a>
                            </li>
                            <li>
                                <a href=""><i className="fas fa-question-circle"></i></a>
                            </li>
                            <li>
                                <a href=""><i className="fas fa-cog"></i></a>
                            </li>
                            <li>
                                <div className="dropdown user-menu">
                                    <a className="dropdown-toggle" href="#" role="button"> Super Admin <img className="user-img" src={`${LOCAL_URL}/images/user-img.png`} /> </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopHeader
